<template>
  <div class="AnalysisName">
    <div id="form-div">
      <div class="row justify-content-center align-items-center px-3">
        <div class="col-md-10">
          {{ $t('crosswalk.analysisName.prompt') }}
        </div>

        <div class="col-md-10">
          <input
              v-model="name"
              @blur="challengeStore.nameChanged()"
              :disabled="!editMode"
          />
        </div>
      </div>

      <div class="sidebar-instructions p-4">
        {{ $t('crosswalk.analysisName.helperText') }}
      </div>
    </div>
  </div>

  <router-view />
</template>

<script src="./_CrosswalkAnalysisName.js" lang="js"></script>
<style src="./_CrosswalkAnalysisName.less" lang="less" scoped></style>
